import { render, staticRenderFns } from "./SdmMovil.vue?vue&type=template&id=3cc5d1c8&scoped=true&"
import script from "./SdmMovil.vue?vue&type=script&lang=js&"
export * from "./SdmMovil.vue?vue&type=script&lang=js&"
import style0 from "./SdmMovil.vue?vue&type=style&index=0&id=3cc5d1c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc5d1c8",
  null
  
)

export default component.exports